import { app } from '../../../../../app';
import { Controller } from './non-domain-protection-key.controller';

app.component('companyManageApplicationIntegrationDevelopersNonDomainProtectionKey', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./non-domain-protection-key.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.component.js